{ "closeAria": "Zamknij", "historyAria": "Historia zgłoszeń", "supportTitle": "Pomoc" }
